import { Button } from "@mui/material";
import CustomCard from "components/common/CustomCard";
import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaPlus } from "react-icons/fa";
import AddMissionExpertSetModal from "../Modal/AddMissionExpertSetModal";
import AddMissionExpertsModalUpdated from "../Modal/AddMissionExpertsModalUpdated";
import { useParams } from "react-router-dom";
import { useGetExpertsByMissionIdQuery } from "modules/pvs_activities/redux/service/missions";


const defaultProps = {
    canModify: false
};


const MissionExpertSets = (rawProps) => {
    const [showMissionExpertModal, setShowMissionExpertModal] = useState(false);
    const props = { ...defaultProps, ...rawProps };
    const { t } = useTranslation();
    const { id } = useParams();
    const experts = useGetExpertsByMissionIdQuery({ missionID: id })

    return (
        <>
            <div className="header d-flex btn-res1 w-100" style={{ backgroundColor: "#E7E5DA" }}>
                <div className="col-12 text-center d-flex justify-content-center gap-4">
                    <div className="card-title1 text-dark my-auto">{t("-1", "Mission Expert Team")}</div>
                    {/* {props.canModify && <AddMissionExpertSetModal />} */}

                    {/* Below button code is hide according to ticket number */}
                    {/* {props.canModify && (<Button color="primary" variant="contained" disableElevation className="my-auto" onClick={() => setShowMissionExpertModal(true)}>     
                        <FaPlus />
                        <span className="ms-1">Add Set</span>
                    </Button>)} */}
                </div>
            </div>
            <CustomCard>
                <Card.Body>
                    <table className="table table-bordered">
                        <thead className="bg-primary text-white">
                            <tr>
                                <th width="50" className="text-center">
                                    #
                                </th>
                                <th>Expert Name</th>
                                <th>Position</th>
                                {/* <th>Peer Reviewer</th>
                                {props.canModify && <th>Actions</th>} */}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                experts.isSuccess && experts.data.length > 0 ? (
                                    experts.data.map((item, index) => (
                                        <tr key={item.id}>
                                            <td className="text-center">{index + 1}</td>
                                            <td>{item.expert?.expert_name}</td>
                                            <td>{item.list_detail?.list_element_name ? item.list_detail.list_element_name : '-'}</td>

                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td className="text-center" colSpan={7}>No Data Found</td>
                                    </tr>
                                )}



                        </tbody>
                    </table>
                </Card.Body>
            </CustomCard>
            <AddMissionExpertsModalUpdated
                isShow={showMissionExpertModal}
                initModal={() => setShowMissionExpertModal(false)}
            />
        </>
    );
};

export default MissionExpertSets;
